module.exports = __webpack_public_path__ + "static/Map-b5a1e7507a969f43d1492dac1f983a9a.svg";